<style scoped lang="scss">
.header-row {
    color: #999;
    font-size: 0.8em;
}
</style>

<template>
    <div class="uk-width-1-1 uk-grid header-row uk-margin-bottom">
        <div class="uk-width-1-5">Application ID: {{ application.id }}</div>
        <div class="uk-width-3-5 uk-text-center">Attestation Document Request by Allita 360</div>
        <div class="uk-width-1-5 uk-text-right">Submitted: {{ application.date_hh_submitted | moment }}</div>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "HeaderRow",
        computed: {
            ...mapState('Application', {
                application: 'application',
            }),
        }
    }
</script>
